import { render, staticRenderFns } from "./CryptoWalletSettingsHome.vue?vue&type=template&id=4397d86a&"
import script from "./CryptoWalletSettingsHome.vue?vue&type=script&lang=js&"
export * from "./CryptoWalletSettingsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports